// Our team's Amigo log (D8). Wording from the Amigo design's copy sheet (Amigo log, Amigo log couldn't do, Amigo log no
// results, Row status); FoodAmigos only, so always Amigo, never the assistant.
export default {
  title: 'Amigo-Protokoll',
  intro:
    'Jede Anfrage, die Amigo bearbeitet hat: was gefragt wurde, wo, wer gefragt und wer freigegeben hat. Nur FoodAmigos sieht diese Seite.',
  // The tab list's name for screen readers.
  tabs_label: 'Amigo-Protokoll',
  tabs: {
    requests: 'Anfragen',
    gaps: 'Nicht möglich',
  },
  filters: {
    restaurant: 'Restaurant',
    all_restaurants: 'Alle Restaurants',
    brand: '{{name}} · Marke',
    restaurant_unknown: 'Restaurant {{id}}',
    searching: 'Restaurants werden gesucht…',
    no_restaurant: 'Kein Restaurant namens „{{query}}“',
    period: 'Zeitraum',
    start_date: 'Startdatum',
    end_date: 'Enddatum',
    refresh: 'Aktualisieren',
    gap: 'Gefragt nach: {{request}}',
    change_set: 'Die Anfrage zu einer Änderung',
    remove: 'Filter entfernen: {{label}}',
    clear: 'Filter zurücksetzen',
  },
  columns: {
    steps: 'Schritte',
    when: 'Wann',
    request: 'Anfrage',
    restaurant: 'Restaurant',
    asked_by: 'Gefragt von',
    result: 'Ergebnis',
  },
  show_steps: 'Schritte anzeigen von: {{request}}',
  approved_by: 'Freigegeben von {{name}}',
  nothing_approved: 'Nichts freigegeben',
  results: {
    applied: '{{applied}} übernommen',
    applied_skipped: '{{applied}} übernommen · {{skipped}} übersprungen',
    partial: '{{applied}} von {{total}} übernommen',
    imported: 'Importiert',
    importing: 'Wird importiert',
    waiting: 'Wartet auf Freigabe',
    rejected: 'Abgelehnt',
    undone: 'Rückgängig gemacht',
    partly_undone: '{{undone}} von {{total}} rückgängig',
    expired: 'Abgelaufen',
    replaced: 'Ersetzt',
    failed: 'Fehlgeschlagen',
    answered: 'Beantwortet',
    not_yet: 'Noch nicht möglich',
    off_limits: 'Gesperrt',
    not_allowed: 'Nicht erlaubt',
    switched_off: 'Ausgeschaltet',
    guard: 'Von einer Sicherheitsprüfung gestoppt',
    not_found: 'Nicht gefunden',
  },
  steps: {
    asked: '{{name}} hat gefragt',
    asked_anonymous: 'Gefragt',
    approved: 'Freigegeben von {{name}}',
    approved_alone: 'Freigegeben',
    applied_one: '{{count}} Änderung übernommen',
    applied_other: '{{count}} Änderungen übernommen',
    failed_one: '{{count}} nicht übernommen',
    failed_other: '{{count}} nicht übernommen',
    rejected: 'Abgelehnt',
    undone: 'Rückgängig gemacht',
    undone_by: 'Rückgängig gemacht, freigegeben von {{name}}',
    skipped_one: '{{count}} übersprungen',
    skipped_other: '{{count}} übersprungen',
    skipped_state: 'Übersprungen',
    more_one: 'und {{count}} weitere',
    more_other: 'und {{count}} weitere',
    changes_one: '{{count}} Änderung',
    changes_other: '{{count}} Änderungen',
    other: 'Etwas geprüft',
  },
  // The line over a request's steps (QA49): how many, how many shop refused, how many failed.
  summary: {
    steps_one: '{{count}} Schritt',
    steps_other: '{{count}} Schritte',
    refused_one: '{{count}} abgelehnt',
    refused_other: '{{count}} abgelehnt',
    failed_one: '{{count}} fehlgeschlagen',
    failed_other: '{{count}} fehlgeschlagen',
  },
  outcomes: {
    title: 'Ergebnis',
    answered: 'Eine Antwort: nichts geändert.',
    waiting: 'Wartet auf Freigabe. Noch nichts geändert.',
    rejected: 'Abgelehnt: nichts geändert.',
    expired: 'Ohne Freigabe abgelaufen: nichts geändert.',
    replaced: 'Durch eine neuere Karte ersetzt: hier nichts geändert.',
    undone: 'Rückgängig gemacht: die Änderungen wurden zurückgenommen.',
    partly_undone: 'Teilweise rückgängig: {{undone}} von {{total}} Änderungen wurden zurückgenommen.',
    failed: 'Fehlgeschlagen: nichts geändert.',
    not_yet: 'Noch nicht möglich: nichts geändert. Unter „Nicht möglich“ gezählt.',
    off_limits: 'Gesperrt: nichts geändert.',
    not_allowed: 'Für die Rolle dieser Person nicht erlaubt: nichts geändert.',
    switched_off: 'Hier ausgeschaltet: nichts geändert.',
    guard: 'Von einer Sicherheitsprüfung gestoppt: nichts geändert.',
    not_found: 'Nicht gefunden: nichts geändert.',
    importing: 'Wird importiert. Jedes Gericht kommt in Menü → Änderungsverlauf.',
    imported: 'Importiert. Jedes Gericht steht in Menü → Änderungsverlauf.',
  },
  changes: {
    where: '{{changes}} · {{where}}',
    title_one: '{{count}} Änderung',
    title_other: '{{count}} Änderungen',
    show_all: 'Alle {{count}} Änderungen zeigen',
    show_fewer: 'Weniger zeigen',
    from: 'von',
    to: 'zu',
    removed: 'Entfernt',
  },
  row_states: {
    skipped: 'Übersprungen',
    failed: 'Nicht übernommen',
    stale: 'Inzwischen geändert',
    kept: 'Bleibt unverändert',
  },
  menu_history: 'Menü → Änderungsverlauf öffnen',
  open_chat: 'Chat öffnen',
  switch_failed: 'Das Restaurant ließ sich nicht öffnen. Versuch es noch einmal.',
  pagination: {
    label: 'Seiten',
    summary: '{{from}}–{{to}} von {{total}} Anfragen',
    previous: 'Vorherige Seite',
    next: 'Nächste Seite',
  },
  empty: {
    title: 'Keine Anfragen für {{restaurant}} in diesem Zeitraum',
    text: 'Amigo hat dort zwischen {{from}} und {{to}} nichts bearbeitet.',
    title_any_day: 'Noch keine Anfragen für {{restaurant}}',
    text_any_day: 'Amigo hat dort noch nichts bearbeitet.',
    title_everywhere: 'Keine Anfragen in diesem Zeitraum',
    text_everywhere: 'Amigo hat zwischen {{from}} und {{to}} nichts bearbeitet.',
    title_nothing: 'Noch keine Anfragen',
    text_nothing: 'Amigo hat noch nichts bearbeitet.',
  },
  loading: 'Wird geladen…',
  error: {
    title: 'Das Protokoll konnte nicht geladen werden',
    text: 'Versuch es gleich noch mal.',
    retry: 'Erneut versuchen',
  },
  gaps: {
    intro:
      'Was Amigo noch nicht konnte, gruppiert nach der Frage, die häufigsten zuerst. Gesperrte Bereiche und Anfragen, die eine Rolle nicht darf, stehen nicht hier.',
    columns: {
      area: 'Bereich',
      request: 'Wonach gefragt wurde',
      count: 'Gefragt',
      last_at: 'Zuletzt',
      requests: 'Anfragen',
    },
    count: '{{count}}×',
    see_requests_one: '{{count}} Anfrage ansehen',
    see_requests_other: '{{count}} Anfragen ansehen',
    today: 'Heute, {{time}}',
    yesterday: 'Gestern, {{time}}',
    empty_title: 'Keine Anfragen, die Amigo nicht konnte',
    empty_text: 'Alles, wonach gefragt wurde, konnte Amigo erledigen.',
  },
  areas: {
    menu: 'Menü',
    hours: 'Öffnungszeiten',
    order_settings: 'Bestelleinstellungen',
    my_info: 'Meine Info',
    marketing: 'Marketing',
    gift_cards: 'Geschenkkarten',
    reports: 'Berichte',
    website: 'Website',
    integrations: 'Integrationen',
    delivery: 'Lieferung',
    payments: 'Zahlungen',
    team: 'Team',
    billing: 'Abrechnung',
    settings: 'Einstellungen',
    other: 'Sonstiges',
  },
};
